import { datadogRum } from "@datadog/browser-rum";
import { inProduction } from "../config";
import { inBrowser } from "./utils/env";
import { isDroppableRumError } from "./utils/rumFilters";

const DD_RUM_APPLICATION_ID = process.env.NEXT_PUBLIC_DD_RUM_APPLICATION_ID;
const DD_RUM_CLIENT_TOKEN = process.env.NEXT_PUBLIC_DD_RUM_CLIENT_TOKEN;
// The commit the production deploy built. Datadog applies the source maps
// uploaded under this same version, so stack traces show our source files.
const DD_RUM_VERSION = process.env.NEXT_PUBLIC_DD_RUM_VERSION;

/**
 * Browser errors only. Server errors reach Datadog as logs, through the Vercel
 * log drain.
 *
 * 10% of sessions: RUM is billed per session and the web has ~1.5M a month.
 * Enough to see which errors happen and how often, not every occurrence.
 * Session replay stays off for now.
 * Typed input is masked because signup forms carry personal data.
 */
export const rumEnabled =
  inBrowser && inProduction && !!DD_RUM_APPLICATION_ID && !!DD_RUM_CLIENT_TOKEN;

if (rumEnabled) {
  datadogRum.init({
    applicationId: DD_RUM_APPLICATION_ID!,
    clientToken: DD_RUM_CLIENT_TOKEN!,
    site: "datadoghq.eu",
    service: "lassie-web",
    env: process.env.NEXT_PUBLIC_APP_ENV,
    version: DD_RUM_VERSION,
    sessionSampleRate: 10,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    // Drops vendor noise (Amplitude, the consent banner, in-app browser
    // bridges); see `rumFilters.ts`. Returning false discards the event.
    beforeSend: (event) => !isDroppableRumError(event),
  });
}
